/** Script generation semantic drop-zone resolver — mirrors `videoInputPorts.ts`. */

import {
  GENERATE_SCRIPT_NODE_AGGREGATE_HANDLE,
  GENERATE_SCRIPT_SOURCE_INPUT_HANDLE,
  SCRIPT_INPUT_PORT_ATTR,
} from './scriptSourceContext'

export const SCRIPT_SOURCE_SECTION_TESTID = 'script-source-input-section'

export interface DropZoneProbeElement {
  closest(selector: string): DropZoneProbeElement | null
  getAttribute(name: string): string | null
}

export interface ResolvedScriptDropTarget {
  targetHandle: string
}

export function resolveGenerateScriptDropTarget(el: DropZoneProbeElement | null): ResolvedScriptDropTarget | null {
  if (!el) return null
  const portEl = el.closest(`[${SCRIPT_INPUT_PORT_ATTR}]`)
  const declaredPort = portEl?.getAttribute(SCRIPT_INPUT_PORT_ATTR)
  if (
    declaredPort === GENERATE_SCRIPT_SOURCE_INPUT_HANDLE ||
    declaredPort === GENERATE_SCRIPT_NODE_AGGREGATE_HANDLE
  ) {
    return { targetHandle: declaredPort }
  }
  if (el.closest(`[data-testid="${SCRIPT_SOURCE_SECTION_TESTID}"]`)) {
    return { targetHandle: GENERATE_SCRIPT_SOURCE_INPUT_HANDLE }
  }
  return null
}
